import { reducer } from '@core-ui/reducers_handlers';
import { Action, handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
import * as actions from './actions';

export interface INotificationState {
  show: boolean;
  type?: 'success' | 'error';
  message?: string;
}

const defaultState = Immutable<INotificationState>({
  show: false,
});

export default handleActions<typeof defaultState>(
  {
    [actions.openNotification.toString()]: (state, { payload }: Action<actions.Notification>) => {
      return state.merge({
        show: true,
        ...payload,
      });
    },
    [actions.closeNotification.toString()]: (state) => {
      return state.set('show', false);
    },
  },
  reducer<typeof defaultState>(actions.reducerName, defaultState),
);
